import { Spinner, Stack } from "@fluentui/react";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { EValidationSeverity, IValidationMessage } from "components/controls/ValidationView/ValidationView.type";
import { EJsonTransformerRuntime, JsonTransformer } from "global/Transform/JsonTransformer";
import { RemoveDeprecatedFields } from "global/Transform/RemoveDeprecatedFields";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ValidationItem from "views/BlueRelationship/ValidationDialog/ValidationItem";

const SystemDiagnosis = () => {
    const state = useSelector((state: RootState) => state);

    const [loading, setLoading] = useState(false);

    const [messages, setlog] = useState<IValidationMessage[]>([]);

    useEffect(() => {
        (async () => {
            debugger;

            const snapshot = state.data.snapshot;
            const jsonNew = structuredClone(state.data.json);

            const t = new RemoveDeprecatedFields({
                config: state.data.config,
                json: jsonNew
            });

            const transformer = new JsonTransformer(
                [t],
                EJsonTransformerRuntime.ESequential
            );


            await transformer.transformAsync(jsonNew, snapshot);

            const messages = t.log.map(t => {
                const message: IValidationMessage = {
                    title: t,
                    type: EValidationSeverity.error
                }
                return message;
            })


            setlog(messages);
        })();
    }, []);


    return (
        <CustomPanel title={"System Diagnosis"}
            canCollapse={true}
            defaultCollapsed={true}
        >
            {loading &&
                <div>
                    <Spinner label={"Loading..."} styles={{ root: { margin: '25px' } }} />
                </div>
            }
            <Stack styles={{ root: { marginTop: '10px' } }}>
                {messages.map((message, ix) =>
                    <Stack.Item key={ix}>
                        <ValidationItem data={message} />
                    </Stack.Item>
                )}
            </Stack>

        </CustomPanel>
    );

}


export default SystemDiagnosis;